import { render, staticRenderFns } from "./SearchGeoForm.vue?vue&type=template&id=04b72615&"
import script from "./SearchGeoForm.vue?vue&type=script&lang=ts&"
export * from "./SearchGeoForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports